






















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Enterprise } from '@/models/admin/enterprise';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { enterpriseService, tenantService } from '@/shared';
import { RoleType, ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class EnterpriseAddPage extends Base {
  public enterprise: Enterprise = new Enterprise();
  public requestProgress: boolean = false;
  public tenant: any[] = [];
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public childMethodToCall: string = '';
  public buttons: any = [];
  public selectedTenantId: number = 0;
  public isEnableEnterprise:boolean = false;
  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'enterprise');

    this.buttons = [
      {
        id: '0',
        type: 'button',
        title: 'Back',
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('enterprise.backButton'),
        click: 'backToList',
        icon: 'fas fa-arrow-circle-left',
      },
    ];
    this.selectedTenantId = Number(this.$route.params.tenantId);
    this.$emit('updateToolBar', this.buttons);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.getTenants();
    this.enterprise.id = Number(this.$route.params.id);
    if (this.selectedTenantId > 0) {
      this.enterprise.tenantId = this.selectedTenantId;
    } else {
      this.enterprise.tenantId = this.userSession.tenantId;
    }

    if (this.enterprise.id) {
      this.getEnterprise();
    }

    var role = [RoleType.EnterpriseAdmin.toString(), RoleType.SuperAdmin.toString(), RoleType.TenantAdmin.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.isEnableEnterprise = isRoleAllowed.includes('E-Admin') || isRoleAllowed.includes('SuperAdmin') || isRoleAllowed.includes('TenantAdmin');
    this.setFields();
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'tenantId',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          label: this.$parent.$tc('enterprise.textFields', 0),
          multiple: false,
          validations: 'required',
          required: true,
          items: this.tenant,
          text: 'name',
          value: 'id',
          disabled: false,
          altag: 'Tenant',
          loading: false,
        },
      },
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 50,
          label: this.$parent.$tc('enterprise.textFields', 1) as string,
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Name', v),
            v => this.alphaSpace(v)
          ]
        },
      },
      {
        key: 'glCompanies',
        type: 'v-alynk-textchip',
        required: true,
        templateOptions: {
          label: this.$parent.$tc('enterprise.textFields', 2),
          multiple: true,
          required: true,
          items: this.enterprise.glCompanies,
          disabled: false,
          rules:[
            v =>this.requiredForArray('Gl Comapny', v)
          ],
          events: {
            onChange: (items, value) => {
              const glIndex = this.enterprise.glCompanies.indexOf(value);
              if (glIndex > -1) {
                this.enterprise.glCompanies.splice(glIndex, 1);
              }
            },
            onRemove: (item, value) => {
              const glIndex = this.enterprise.glCompanies.indexOf(value);
              if (glIndex > -1) {
                this.enterprise.glCompanies.splice(glIndex, 1);
              }
            },
          },
          loading: false,
        },
      },
      {
        key: 'isEnabled',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          display: this.isEnableEnterprise,
          disabled: false,
          required: false,
          label: 'Enable Enterprise',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
        },
      },
    ];
  }
  public async getEnterprise(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const enterprise = await enterpriseService.getAsync(this.enterprise.id);

      this.enterprise = enterprise;
      this.enterprise.glCompanies = this.enterprise.glCompanies || [];
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public enterpriseValidate(): Vue & { validate: () => boolean } {
    return this.$refs.enterpriseForm as Vue & { validate: () => boolean };
  }

  public async submitEnterprises(): Promise<void> {
    if(this.enterpriseValidate().validate()){
      var validateRes = this.$validator.errors.items.length > 0;
      if (validateRes) {
        this.showAlert(false, 'Please Enter Valid Details');
        return;
      }
      try {
        await this.delay(300);
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);

        if (this.$route.params.id) {
          await enterpriseService.updateAsync(this.enterprise);
          this.showAlert(true, this.$parent.$t('enterprise.updateAlert'));
          this.$router.push({ name: 'admin.enterprises' });
        } else {
          await enterpriseService.addAsync(this.enterprise);
          this.showAlert(true, this.$parent.$t('enterprise.saveAlert'));
          this.$router.push({
            name: 'admin.enterprisesPage',
            params: {
              tenantId: this.enterprise.tenantId.toString(),
            },
          });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public async getTenants(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const tenants = await tenantService.getAllAsync();
      this.tenant = tenants.results;
      const tenantField = this.formFields.find((m) => {
        return m.key === 'tenantId';
      });
      if (tenantField) {
        tenantField.templateOptions.items = this.tenant;
        tenantField.templateOptions.disabled = true;
      }
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public async callMethod(methodName): Promise<void> {
    if (methodName === 'backToList') {
      this.$router.push({ name: 'admin.enterprises' });
    } else if (methodName === 'submitEnterprises') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is not valid!');
        this.resetMethodName(methodName);
        return;
      }
      await this.submitEnterprises();
    }
    this.resetMethodName(methodName);
  }

  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
}
